
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M16.7 1.304v15.4H1.3v-15.4h15.4m.3-1.3H.997a1 1 0 00-1 1v16a1 1 0 001 1h16.005a1 1 0 001-1V.998a1 1 0 00-1-1z"}}),_c('path',{staticClass:"a",attrs:{"d":"M9.87 5.257a.862.862 0 11-.252-.624.845.845 0 01.252.624zM8.31 13.62V7.004h1.368v6.611z"}})])
          )
        }
      }
    